import React from 'react';
import { styles } from '../../styles/theme';

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange
}) => {
  const pageNumbers = [];
  const maxVisiblePages = 5;

  // Calculate visible page range
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const buttonStyle = {
    ...styles.button,
    ...styles.buttonSecondary,
    padding: '8px 12px',
    fontSize: '13px',
    minWidth: '36px',
  };

  const activeButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#58a6ff',
    borderColor: '#58a6ff',
    color: '#ffffff',
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    opacity: 0.5,
    cursor: 'not-allowed',
  };

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px',
      borderTop: '1px solid #30363d',
      gap: '16px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ color: '#7d8590', fontSize: '13px' }}>
          Mostrando {Math.min((currentPage - 1) * itemsPerPage + 1, totalItems)} - {Math.min(currentPage * itemsPerPage, totalItems)} de {totalItems} itens
        </span>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          style={{
            ...styles.select,
            padding: '6px 10px',
            fontSize: '13px',
          }}
        >
          <option value={10}>10 por pagina</option>
          <option value={25}>25 por pagina</option>
          <option value={50}>50 por pagina</option>
          <option value={100}>100 por pagina</option>
        </select>
      </div>

      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        <button
          style={currentPage === 1 ? disabledButtonStyle : buttonStyle}
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          title="Primeira pagina"
        >
          {'<<'}
        </button>
        <button
          style={currentPage === 1 ? disabledButtonStyle : buttonStyle}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          title="Pagina anterior"
        >
          {'<'}
        </button>

        {startPage > 1 && (
          <>
            <button
              style={buttonStyle}
              onClick={() => onPageChange(1)}
            >
              1
            </button>
            {startPage > 2 && (
              <span style={{ color: '#7d8590', padding: '0 4px' }}>...</span>
            )}
          </>
        )}

        {pageNumbers.map((number) => (
          <button
            key={number}
            style={currentPage === number ? activeButtonStyle : buttonStyle}
            onClick={() => onPageChange(number)}
          >
            {number}
          </button>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <span style={{ color: '#7d8590', padding: '0 4px' }}>...</span>
            )}
            <button
              style={buttonStyle}
              onClick={() => onPageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          style={currentPage === totalPages ? disabledButtonStyle : buttonStyle}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          title="Proxima pagina"
        >
          {'>'}
        </button>
        <button
          style={currentPage === totalPages ? disabledButtonStyle : buttonStyle}
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          title="Ultima pagina"
        >
          {'>>'}
        </button>
      </div>
    </div>
  );
};

export default Pagination;
